<template>
  <div id="conteudo-chat" class="col-md-6">
    <div class="card">
      <div class="card-header">
        Mensagens
      </div>
      <div id="caixa-chat" class="card-body">

        <div v-if='messages && messages.length' id="chat" class="">

          <div v-for='line in messages' id="">

            <div v-if="line.para_id == para_id " class="text-left alert alert-dark">
              <span style="color: #848484;">{{ line.de.name }}</span>
              <span style="color: black;">{{ line.mensagem }}</span>
            </div>
            <div v-else class="text-right alert alert-primary ">
              <div class="">
                <span style="color: #1C62C4;">{{ line.de.name }}</span>
                <span style="color: black;">{{ line.mensagem }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <div class="form-group" style="display:flex;">
          <div class="input-group">
            <input id="message" v-model='message' class="form-control"
                   placeholder="Escreva sua mensagem aqui..." type="text"
                   @keyup.enter.stop.prevent='sendMesaage'>
            <div class="input-group-append">
              <button id="btn-chat" class="btn btn-primary" v-on:click.stop.prevent="sendMesaage">
                <span class="glyphicon glyphicon-send"></span> Enviar
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: [
    "name",
    "session_messages",
    "para_id"
  ],
  data () {
    return {
      // moment: moment,
      messages: [],
      message: '',
      atualizar: true,
      insteval: null,
      tamanho: 0,
      meu_id: null,
      // name: $('.dropdown .dropdown-toggle').text()
    }
  },
  // watch: {
  //   messages: function (val) {
  //     // this.fullName = val + ' ' + this.lastName
  //     let scroll = $('#caixa-chat');
  //     scroll.animate({scrollTop: scroll.prop("scrollHeight")});
  //   },
  // },
  methods: {
    sendMesaage () {
      let mensagem = this.message;
      //Clean value;
      this.message = "";
      if (mensagem !== "") {
        let that = this;
        axios.post('/chat/admin', {mensagem: mensagem, para_id: this.para_id})
            .then(response => {
              that.getMessages();
            });
      }
    },
    getMessages () {
      let that = this;
      axios.get('/chat/mensagens/' + this.para_id).then(
          response => {
            let data = response.data;
            that.meu_id = data.meu_id;
            if (that.messages.length !== data.mensagens.length) {
              that.messages = data.mensagens;
              let scroll = $('#caixa-chat');
              scroll.animate({scrollTop: scroll.prop("scrollHeight")});
            }
          }
      )
    }
  },
  mounted () {
    let that = this;
    this.insteval = setInterval(function () {
      that.getMessages();
    }, 5000);
  }
}

</script>

<style>

#caixa-chat {
  height: 400px;
  overflow: auto;

}

input[type=text] {
  width: 100%;
  height: 40px;
  border: 1px solid gray;
  border-radius: 5px;
}

input[type=submit] {
  width: 100%;
  height: 40px;
  border: 1px solid gray;
  border-radius: 5px;
  cursor: pointer;

}

textarea {
  width: 100%;
  height: 40px;
  border: 1px solid gray;
  border-radius: 5px;
}

input, textarea {
  margin-bottom: 3px;
}

.media {
  overflow: auto;
}

.text-left.alert.alert-dark {
  margin-right: 35px;
}

.text-right.alert.alert-primary {
  margin-left: 35px;
}

.alert {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}

.alert-primary {
  color: #004085;
  background-color: #cce5ff;
  border-color: #b8daff;
}

.alert-dark {
  color: #1b1e21;
  background-color: #d6d8d9;
  border-color: #c6c8ca;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1.25rem;
}

.card-footer:last-child {
  border-radius: 0 0 calc(0.25rem - 1px) calc(0.25rem - 1px);
}

.card-footer {
  padding: 0.75rem 1.25rem;
  background-color: rgba(0, 0, 0, .03);
  border-top: 1px solid rgba(0, 0, 0, .125);
}

.card-footer:last-child {
  border-radius: 0 0 calc(0.25rem - 1px) calc(0.25rem - 1px);
}

.card-footer {
  padding: 0.75rem 1.25rem;
  background-color: rgba(0, 0, 0, .03);
  border-top: 1px solid rgba(0, 0, 0, .125);
}

.form-group {
  margin-bottom: 1rem;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}

.input-group-append {
  margin-left: -1px;
}

.input-group-append, .input-group-prepend {
  display: flex;
}

.input-group > .custom-select:not(:last-child), .input-group > .form-control:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group > .custom-file, .input-group > .custom-select, .input-group > .form-control, .input-group > .form-control-plaintext {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
  margin-bottom: 0;
}

input[type=text] {
  width: 100%;
  height: 40px;
  border: 1px solid gray;
  border-radius: 5px;
}

.form-control {
  display: block;
  width: 100%;
  height: calc(1.6em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: .9rem;
  font-weight: 400;
  line-height: 1.6;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}

</style>
